import { IInitialFormData, TTypeOfEditApkModalWindow } from './editApkContext';
import { IFileData, IEditApk, TApkType, TParametersOfApkType } from 'types';

export enum EditApkActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VERSION_NAME = 'CHANGE_VERSION_NAME',
	CHANGE_VERSION_CODE = 'CHANGE_VERSION_CODE',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	CHANGE_APPLICATION_ID = 'CHANGE_APPLICATION_ID',
	SET_PARAMETER_OF_APK_TYPE = 'SET_PARAMETER_OF_APK_TYPE',
	SET_ID_APK_TYPE = 'SET_ID_APK_TYPE',
	TOGGLE_CUTOVER_BEFORE_UPDATE = 'TOGGLE_CUTOVER_BEFORE_UPDATE',
	CHANGE_FILE_DATA = 'CHANGE_FILE_DATA',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditApkActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditApkActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditApkActionTypes.SET_ALL_DATA;
	payload: {
		apkID: string;
		versionName: string;
		versionCode: string;
		description: string;
		applicationId: string;
		parameterOfApkType: Nullable<TParametersOfApkType>;
		IDApkType: Nullable<TApkType>;
		isCutoverBeforeUpdate: boolean;
		filePath: string;
	};
}

interface IChangeVersionName {
	type: EditApkActionTypes.CHANGE_VERSION_NAME;
	payload: {
		versionName: string;
	};
}

interface IChangeVersionCode {
	type: EditApkActionTypes.CHANGE_VERSION_CODE;
	payload: {
		versionCode: string;
	};
}

interface IChangeDescription {
	type: EditApkActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: string;
	};
}

interface IChangeApplicationId {
	type: EditApkActionTypes.CHANGE_APPLICATION_ID;
	payload: {
		applicationId: string;
	};
}

interface ISetParameterOfApkType {
	type: EditApkActionTypes.SET_PARAMETER_OF_APK_TYPE;
	payload: {
		parameterOfApkType: Nullable<TParametersOfApkType>;
	};
}

interface ISetIDApkType {
	type: EditApkActionTypes.SET_ID_APK_TYPE;
	payload: {
		IDApkType: Nullable<TApkType>;
	};
}

interface IToggleCutoverBeforeUpdate {
	type: EditApkActionTypes.TOGGLE_CUTOVER_BEFORE_UPDATE;
}

interface IChangeFileHash {
	type: EditApkActionTypes.CHANGE_FILE_DATA;
	payload: {
		fileData: IFileData;
	};
}

interface ISetDataForSubmit {
	type: EditApkActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditApk | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditApkActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditApkModalWindow;
	};
}

interface IResetSelectedControls {
	type: EditApkActionTypes.RESET_FIELDS;
}

export type TEditApkAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVersionName
	| IChangeVersionCode
	| IChangeDescription
	| IChangeApplicationId
	| ISetParameterOfApkType
	| ISetIDApkType
	| IToggleCutoverBeforeUpdate
	| IChangeFileHash
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
